// Keep in sync with 'UserValidationConstants.cs'

export const userMobileNumberMaxLength = 29;
